import type { IValidatedResponse } from '../httpClient';
import { getRequest } from '../httpClient';
import type { IDatabaseStatsResponse } from './database-stats-response';
import { databaseStatsResponseSchema } from './database-stats-response';

export async function getDatabaseStatsApi(): Promise<IValidatedResponse<IDatabaseStatsResponse>> {
  return getRequest<IDatabaseStatsResponse>({
    path: '/sys/database',
    schema: databaseStatsResponseSchema,
  });
}
